<script setup lang="ts">
/*
  Where a project or a dataspace lives: the department it is in, or "Personal".

  One badge for every list that shows it — the Designer's cards, the Operator's table and the
  control center's — so a space reads the same wherever it is met. A department is the accent of
  information (its name is the point); personal is the neutral default and does not compete.
*/
import { mdiAccountOutline, mdiOfficeBuildingOutline } from "@mdi/js";
import { HabBadge } from "@livereader/habitus-vue";
import type { DepartmentRef } from "@/api";

defineProps<{
	/** The department it is in; `null` for a personal space. */
	department: DepartmentRef | null;
}>();
</script>

<template>
	<HabBadge
		:icon="department ? mdiOfficeBuildingOutline : mdiAccountOutline"
		:tone="department ? 'info' : 'neutral'"
	>
		{{ department ? department.name : $t("spaces.personal") }}
	</HabBadge>
</template>
